import { http } from "msw";
import {
  getAllArticles,
  getAllFeeds,
  getProductFeeds,
  getMyBlocks,
  getProducts,
  getMyBlockCategories,
  getProductCategories,
  getArticleCategories,
} from "./resolvers/apiBlocks";
import {
  getAllAutosaves,
  getAutosave,
  addAutosave,
} from "./resolvers/autosaves";
import {
  getAllComments,
  detailConversation,
  addComment,
  postToComment,
  deleteComment,
  deleteConversation,
  resolveConv,
} from "./resolvers/comments";
import {
  getSavedBlocks,
  addSavedBlock,
  replaceBlock,
  deleteSavedBlock,
} from "./resolvers/savedBlocks";
import {
  getAllSyncedSections,
  getOneSyncedRow,
  createSyncedRow,
  editSyncedRow,
  deleteSyncedRow,
} from "./resolvers/syncedSections";
import { getDynamicFeeds } from "./resolvers/dynamicFeeds";

export const handlers = [
  http.get(
    "https://private-68405b-products174.apiary-mock.com/articles",
    getAllArticles
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/article-feeds",
    getAllFeeds
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/feeds",
    getProductFeeds
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/products",
    getProducts
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/my-block",
    getMyBlocks
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/my-block-feeds",
    getAllFeeds
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/my-block-categories",
    getMyBlockCategories
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/product-categories",
    getProductCategories
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/article-categories",
    getArticleCategories
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/autosaves",
    getAllAutosaves
  ),

  http.get(
    "https://private-68405b-products174.apiary-mock.com/get-autosave/:autosaveId",
    getAutosave
  ),

  http.post(
    "https://private-68405b-products174.apiary-mock.com/autosave",
    addAutosave
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/conversations",
    getAllComments
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/conversations/:convId",
    detailConversation
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/conversations/:convId",
    addComment
  ),

  http.delete(
    "http://private-b2d8b-editor4.apiary-mock.com/conversations/:convId",
    deleteConversation
  ),

  http.patch(
    "http://private-b2d8b-editor4.apiary-mock.com/conversations/:convId",
    resolveConv
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/comments/:commentId",
    postToComment
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/saved-blocks",
    getSavedBlocks
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/saved-blocks",
    addSavedBlock
  ),

  http.patch(
    "http://private-b2d8b-editor4.apiary-mock.com/saved-blocks/:savedId",
    replaceBlock
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/saved-blocks/delete",
    deleteSavedBlock
  ),

  http.delete(
    "http://private-b2d8b-editor4.apiary-mock.com/comments/:commentId",
    deleteComment
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/synced-rows",
    getAllSyncedSections
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/synced-rows",
    createSyncedRow
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/synced-rows/:rowId",
    getOneSyncedRow
  ),

  http.patch(
    "http://private-b2d8b-editor4.apiary-mock.com/synced-rows/:rowId",
    editSyncedRow
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/synced-rows/delete",
    deleteSyncedRow
  ),

  http.get(
    "http://private-b2d8b-editor4.apiary-mock.com/dynamic-feeds",
    getDynamicFeeds
  ),

  http.post(
    "http://private-b2d8b-editor4.apiary-mock.com/upload-my-test",
    () => {
      return new Response(
        JSON.stringify({
          success: true,
          url: "http://191n.mj.am/img/191n/1t/hs.png",
        }),
        {
          status: 200,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  ),
  // http.get(
  //   "https://ff1rg3fntb.execute-api.eu-central-1.amazonaws.com/folders/aqmRe2V4AoYxAqDmjUABxTFwouuBSyv5gdV173acdt4Rt7XrUBrkN1K97iaz",
  //   getFMData
  // ),
];

// The AI translation endpoint is mocked ONLY in testing mode (Playwright runs
// via `vite --mode testing`). In development (`bun dev`) and production it is
// left unmocked so you hit the REAL backend against production/local/stage.
// The matcher is host-agnostic (path-based) so the test mock still applies when
// CI points the app at a real lambda stage (s1/s2/s3.api.topol.io) via the
// test-stage PR label — a hardcoded api.topol.io host would miss those and let
// requests reach the real, non-deterministic backend, breaking the
// "[translated]" assertions. (Playwright page.route can't replace this: MSW's
// service worker handles the request before it reaches the network layer, so
// page.route never sees it.)
if (import.meta.env.MODE === "testing") {
  handlers.push(
    http.post(/\/email\/translation$/, async ({ request }) => {
      const body = await request.json();
      const keyValue = body.keyValue ?? [];
      return new Response(
        JSON.stringify({
          data: keyValue.map((k) => ({
            uid: k.uid,
            content: `[translated] ${k.content}`,
          })),
          detectedLanguage: "English",
        }),
        {
          status: 200,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    })
  );
}
